import { z } from 'zod'
import { apiResponseSchema } from './api-response-schema'

export const loginSchema = z.object({
  email: z.string().min(1, "L'email est requis").email("Format d'email invalide"),
  password: z.string().min(1, "Le mot de passe est requis").min(6, "Le mot de passe doit contenir au moins 6 caractères"),
})

export const loginSchemaResponse = apiResponseSchema.extend({
  data: z.object({
    accessToken: z.string(),
    refreshToken: z.string().optional(), // Le refresh token peut être optionnel selon l'API
    user: z.object({
      id: z.string(),
      email: z.string().email(),
      name: z.string(),
    })
  })
})